module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "gutter": 20
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "80px"
    },
    model: {
      value: (_vm.CreativeForm),
      callback: function($$v) {
        _vm.CreativeForm = $$v
      },
      expression: "CreativeForm"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.AdsForm.delivery_range == 'DEFAULT') ? _c('el-form-item', {
    attrs: {
      "label": "投放位置"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.CreativeForm.inventory),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "inventory", $$v)
      },
      expression: "CreativeForm.inventory"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "smart_inventory"
    }
  }, [_vm._v("优选广告位")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "inventory_type"
    }
  }, [_vm._v("按媒体指定位置")]), _vm._v("、\n\t\t\t\t\t  "), _c('el-radio-button', {
    attrs: {
      "label": "scene_inventory"
    }
  }, [_vm._v("按场景指定位置")])], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.CreativeForm.inventory == 'scene_inventory') && (_vm.AdsForm.delivery_range == 'DEFAULT')) ? _c('el-form-item', [_c('el-radio-group', {
    model: {
      value: (_vm.CreativeForm.scene_inventory),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "scene_inventory", $$v)
      },
      expression: "CreativeForm.scene_inventory"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "VIDEO_SCENE"
    }
  }, [_vm._v("沉浸式竖版视频场景广告位")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "FEED_SCENE"
    }
  }, [_vm._v("信息流场景广告位")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "TAIL_SCENE"
    }
  }, [_vm._v("视频后贴和尾帧场景广告位")])], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.CreativeForm.inventory == 'inventory_type') && (_vm.AdsForm.delivery_range == 'DEFAULT')) ? _c('el-form-item', [_c('el-checkbox-group', {
    model: {
      value: (_vm.CreativeForm.inventory_type),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "inventory_type", $$v)
      },
      expression: "CreativeForm.inventory_type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "INVENTORY_FEED"
    }
  }, [_vm._v("头条系")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "INVENTORY_VIDEO_FEED"
    }
  }, [_vm._v("西瓜信息流")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "INVENTORY_HOTSOON_FEED"
    }
  }, [_vm._v("火山信息流")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "INVENTORY_AWEME_FEED"
    }
  }, [_vm._v("抖音信息流")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabed": "",
      "label": "INVENTORY_UNION_SLOT"
    }
  }, [_vm._v("穿山甲")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创意方式"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.CreativeForm.creative_material_mode),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "creative_material_mode", $$v)
      },
      expression: "CreativeForm.creative_material_mode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "CUSTOM_ASSEMBLE"
    }
  }, [_vm._v("自定义创意")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "STATIC_ASSEMBLE"
    }
  }, [_vm._v("程序化创意")])], 1)], 1), _vm._v(" "), (_vm.AdsForm.download_type == 'EXTERNAL_URL') ? _c('el-form-item', {
    attrs: {
      "label": "来源"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.CreativeForm.source),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "source", $$v)
      },
      expression: "CreativeForm.source"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v("素材内容 "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.openModel
    }
  }, [_vm._v("+添加")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "my-video-list video_list",
    staticStyle: {
      "max-height": "400px",
      "border": "1px dotted #ebebeb",
      "padding": "5px",
      "overflow-y": "auto"
    }
  }, [_c('ul', {
    staticStyle: {
      "width": "100%",
      "padding": "0px 10px"
    }
  }, _vm._l((_vm.creativeslist), function(o, c) {
    return _c('li', {
      staticClass: "list_item"
    }, [_c('div', {
      staticClass: "list_image"
    }, [_c('img', {
      staticClass: "ga-mod-cover",
      attrs: {
        "src": o.img_url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title-wrap"
    }, [(o.title) ? _c('div', {
      staticClass: "main ga-title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t  " + _vm._s(o.title) + "\n\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "right",
        "padding": "5px"
      }
    }, [_c('el-dropdown', [_c('span', {
      staticClass: "el-dropdown-link",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v("操作"), _c('i', {
      staticClass: "el-icon-arrow-down el-icon--right"
    })]), _vm._v(" "), _c('el-dropdown-menu', {
      attrs: {
        "slot": "dropdown"
      },
      slot: "dropdown"
    }, [_c('el-dropdown-item', {
      nativeOn: {
        "click": function($event) {
          return _vm.editCreate(c, o)
        }
      }
    }, [_vm._v("修改")]), _vm._v(" "), _c('el-dropdown-item', {
      nativeOn: {
        "click": function($event) {
          return _vm.removeCreate(c, o)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)], 1)])])
  }), 0)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [(_vm.CreativeForm.creative_material_mode == 'STATIC_ASSEMBLE') ? _c('el-form-item', {
    attrs: {
      "label": "创意标题"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.CreativeForm.title_list_string),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "title_list_string", $$v)
      },
      expression: "CreativeForm.title_list_string"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应用名"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.CreativeForm.app_name),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "app_name", $$v)
      },
      expression: "CreativeForm.app_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.CreativeForm.advanced_creative_title),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "advanced_creative_title", $$v)
      },
      expression: "CreativeForm.advanced_creative_title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "衍生计划"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.CreativeForm.generate_derived_ad),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "generate_derived_ad", $$v)
      },
      expression: "CreativeForm.generate_derived_ad"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("不启用")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("启用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创意展现"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.CreativeForm.creative_display_mode),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "creative_display_mode", $$v)
      },
      expression: "CreativeForm.creative_display_mode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "CREATIVE_DISPLAY_MODE_CTR"
    }
  }, [_vm._v("优选模式")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "CREATIVE_DISPLAY_MODE_RANDOM"
    }
  }, [_vm._v("轮播模式")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('el-form-item', {
    attrs: {
      "label": "创意分类"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "size": "mini",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.CreativeForm.third_industry_id),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "third_industry_id", $$v)
      },
      expression: "CreativeForm.third_industry_id"
    }
  }, _vm._l((_vm.industrylist), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "创意标签"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "最多20个标签，每个不超过10个字，请用#分割"
    },
    model: {
      value: (_vm.CreativeForm.ad_keywords),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "ad_keywords", $$v)
      },
      expression: "CreativeForm.ad_keywords"
    }
  })], 1), _vm._v(" "), (_vm.AdsForm.delivery_range == 'UNION' && _vm.AdsForm.union_video_type == 'REWARDED_VIDEO') ? _c('el-form-item', {
    attrs: {
      "label": "试玩素材"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.playableSwitch),
      callback: function($$v) {
        _vm.playableSwitch = $$v
      },
      expression: "playableSwitch"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.playableSwitch && _vm.AdsForm.delivery_range == 'UNION' && _vm.AdsForm.union_video_type == 'REWARDED_VIDEO') ? _c('el-form-item', {
    attrs: {
      "label": "选择素材"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "请输入试玩链接地址"
    },
    on: {
      "select": _vm.handleSelectPlay
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "name",
          staticStyle: {
            "color": "#537ec5"
          }
        }, [_vm._v(_vm._s(item.playable_name))]), _vm._v(" "), _c('span', {
          staticClass: "addr"
        }, [_vm._v(_vm._s(item.playable_url))])]
      }
    }], null, false, 83356927),
    model: {
      value: (_vm.CreativeForm.playable_url),
      callback: function($$v) {
        _vm.$set(_vm.CreativeForm, "playable_url", $$v)
      },
      expression: "CreativeForm.playable_url"
    }
  })], 1) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "demo-drawer__footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.cancelOpen
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.saveCreative
    }
  }, [_vm._v("修改保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "广告素材上传",
      "visible": _vm.materialDialogVisible,
      "append-to-body": true,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.materialDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "materialContain"
  }, [_c('el-form', {
    staticClass: "demo-dynamic",
    attrs: {
      "model": _vm.form
    }
  }, [(_vm.CreativeForm.creative_material_mode == 'CUSTOM_ASSEMBLE') ? _c('el-form-item', {
    attrs: {
      "label": "创意标题"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "素材类型"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.form.image_mode),
      callback: function($$v) {
        _vm.$set(_vm.form, "image_mode", $$v)
      },
      expression: "form.image_mode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "CREATIVE_IMAGE_MODE_VIDEO"
    }
  }, [_vm._v("横版视频")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "CREATIVE_IMAGE_MODE_VIDEO_VERTICAL"
    }
  }, [_vm._v("竖版视频")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "disabled": "",
      "label": "CREATIVE_IMAGE_MODE_SMALL"
    }
  }, [_vm._v("小图")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "disabled": "",
      "label": "CREATIVE_IMAGE_MODE_LARGE"
    }
  }, [_vm._v("大图")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "disabled": "",
      "label": "CREATIVE_IMAGE_MODE_GROUP"
    }
  }, [_vm._v("组图")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "素材内容"
    }
  }, [_c('el-row', [_vm._l((_vm.selectVideo), function(item) {
    return _c('div', {
      staticClass: "add_avatar",
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_c('img', {
      staticClass: "avatar-uploader-icon",
      attrs: {
        "src": item.poster_url
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "el-upload-list__item-actions"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "选择封面图",
        "placement": "top"
      }
    }, [_c('span', {
      staticClass: "el-upload-list__item-preview",
      on: {
        "click": function($event) {
          return _vm.video_cover(item)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-picture-outline"
    })])]), _vm._v(" "), _c('span', {
      staticClass: "el-upload-list__item-preview",
      on: {
        "click": function($event) {
          return _vm.deleteSelVideo(item)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete"
    })])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "add_avatar",
    on: {
      "click": function($event) {
        return _vm.libDialogOpen()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 2), _vm._v(" "), _c('LibPanel', {
    ref: "Lib",
    on: {
      "func": _vm.getSelectVideo
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('span', [_vm._v("封面选取"), _c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(*必选)")])]), _vm._v(" "), _c('el-row', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.thumbLoading),
      expression: "thumbLoading"
    }]
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.handleThumb
    },
    model: {
      value: (_vm.selectThumb),
      callback: function($$v) {
        _vm.selectThumb = $$v
      },
      expression: "selectThumb"
    }
  }, _vm._l((_vm.thumb_List), function(i) {
    return _c('div', {
      staticClass: "add_avatar thumb_list",
      staticStyle: {
        "border": "none"
      }
    }, [_c('img', {
      staticClass: "el-image__inner",
      attrs: {
        "src": i.url
      }
    }), _vm._v(" "), _c('el-radio', {
      staticClass: "thumb_select",
      attrs: {
        "label": i
      }
    }, [_vm._v(" ")])], 1)
  }), 0)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.materialDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.materialConfirm
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bd48142"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adv/model/edit/creative.vue
// module id = 1097
// module chunks = 36